<script setup lang="ts">

import type MapCoordinate from '@/types/MapCoordinate.ts'
import {computed} from "vue";
import { useGameStore } from '@/stores/gameStore.ts'
import { usePortalStore } from '@/stores/portalStore.ts'
import PositionIcon from '@/components/Interface/PositionIcon.vue'

const gameStore = useGameStore()
const portalStore = usePortalStore()

const props = defineProps<{
  coordinate: MapCoordinate
}>();

const portalData = computed(() => {
  return portalStore.findPortalById(props.coordinate.typeId)!
})

const targetPortalData = computed(() => {
  return portalStore.findPortalById(portalData.value.targetPortalId)!
})

</script>

<template>
  <div class="background border-slate-800 border">
    <div class="flex justify-center items-center star-image">
      <img :src="gameStore.cdnUrl + '/images/map/blackhole.webp'" class="w-full h-full" alt=""/>
    </div>
    <div class="flex justify-between px-2 py-1">
      <div>Target</div>
      <div v-if="targetPortalData" class="text-slate-300">{{ targetPortalData.name }} <PositionIcon :x="targetPortalData.xPos" :y="targetPortalData.yPos"/></div>
      <div v-else>Unknown</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.star-image {
  height:9.9rem;
  width:9.9rem;
  overflow: hidden;
}
.background {
  background-image: url("https://cdn.ferion.com/images/backgrounds/space.webp");
}
</style>